<template>
  <div class="synopsis">
    <img src="../assets/synopsis.png" mode="widthFix" class="synopsis_image" />
    <div class="synopsis_body">
      <div class="body_h1">循卷二手旧书回收收书</div>
      <div class="body_h2">
        我们真诚回收您的闲置书籍，让您不再为廉价处理书籍而苦恼
      </div>
      <div class="body_h2" style="margin: 38px 0">
        我们精心翻新所有书籍，让它们可以有尊严的重生
      </div>
      <div class="body_h2">
        我们为所有书籍标记专属“谷书码”，让您和书籍的所有主人以书会友，共享读书笔记
      </div>
      <div class="body_h2" style="margin-top: 38px">
        我们低价出售您所需的书籍，为您最大程度的降低购书成本
      </div>
      <div class="body_h3">选择循卷二手旧书回收收书，为您的书籍选择一个永不退场的归宿!</div>
    </div>
    <div class="introduce1 flex">
      <img src="../assets/img1.png" alt="" />
      <div>
        <div class="introduce_title">
          <div></div>
          真诚回收您的闲置书籍
        </div>
        <div class="introduce_title" style="margin: 30px 0">
          <div></div>
          让您的书籍不再“廉价”
        </div>
        <div class="introduce_label">让旧书循环利用，让买书经济实惠</div>
      </div>
    </div>
    <div class="introduce2 flex">
      <div>
        <div class="introduce_title">
          <div></div>
          精心消毒、翻新所有书籍
        </div>
        <div class="introduce_title" style="margin: 30px 0">
          <div></div>
          让它们有尊严的“重生”
        </div>
        <div class="introduce_label">让每一本书有来路，亦有归途</div>
      </div>
      <img src="../assets/img2.png" alt="" />
    </div>
    <div class="introduce3 flex">
      <img src="../assets/img3.png" alt="" />
      <div>
        <div class="introduce_title">
          <div></div>
          为所有书籍标记
        </div>
        <div class="introduce_title" style="margin: 30px 0">
          <div></div>
          专属“小程序名字”
        </div>
        <div class="introduce_title" style="margin-bottom: 30px">
          <div></div>
          让哎书的人以书会友
        </div>
        <div class="introduce_title">
          <div></div>
          共享读书笔记
        </div>
        <div class="introduce_label" style="margin-top: 30px">
          让旧书循环利用，让买书经济实惠
        </div>
      </div>
    </div>
    <div class="introduce4 flex">
      <div>
        <div class="introduce_title">
          <div></div>
          低价出售您所需的书籍
        </div>
        <div class="introduce_title" style="margin: 30px 0">
          <div></div>
          为您最大程度节约购书成本
        </div>
        <div class="introduce_label">先择循卷二手旧书回收收书</div>
      </div>
      <img src="../assets/img4.png" alt="" />
    </div>
  </div>
</template>

<script>
export default {
  name: "Synopsis",
  data() {
    return {};
  },
  methods: {}
};
</script>
<style>
.flex {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
<style lang="scss" scoped>
.synopsis_body {
  width: 100%;
  height: 816px;
  background: linear-gradient(180deg, #fff7ea 0%, #fffbf8 100%);
  text-align: center;
  padding-top: 74px;
  box-sizing: border-box;
  .body_h1 {
    font-size: 60px;
    font-weight: bold;
    margin-bottom: 81px;
  }
  .body_h2 {
    font-size: 35px;
  }
  .body_h3 {
    margin-top: 82px;
    font-size: 45px;
    font-weight: bold;
    color: #447849;
  }
}
.introduce1 {
  width: 100%;
  height: 587px;
  background: #ffffff;
  padding-top: 78px;
  box-sizing: border-box;
  img {
    width: 571px;
    height: 439px;
    margin-right: 15px;
  }
}
.introduce_title {
  display: flex;
  align-items: center;
  text-align: left;
  font-size: 30px;
  div {
    width: 24px;
    height: 24px;
    margin-right: 20px;
    background-color: transparent; /* 背景色设为透明 */
    border-radius: 50%;
    border: 4px solid #447849;
  }
}
.introduce_label {
  font-size: 45px;
  font-weight: bold;
  color: #447849;
  text-align: left;
}
.introduce2 {
  width: 100%;
  height: 587px;
  background: #fffaf4;
  padding-top: 70px;
  box-sizing: border-box;
  img {
    width: 593px;
    height: 460px;
    margin-left: 183px;
  }
}
.introduce3 {
  width: 100%;
  height: 631px;
  background: #ffffff;
  padding-top: 106px;
  box-sizing: border-box;
  img {
    width: 501px;
    height: 417px;
    margin-right: 59px;
  }
}
.introduce4 {
  width: 100%;
  height: 587px;
  background: #fffaf4;
  padding-top: 70px;
  box-sizing: border-box;
  img {
    width: 590px;
    height: 464px;
    margin-left: 360px;
  }
}
.synopsis {
  width: 100%;
}
.synopsis_image {
  width: 100%;
  display: block;
}
</style>
